import React from 'react';
import { StyleSheet } from 'react-native';
import { Colors } from '../constants';
import { useDynamicStyles } from '../hooks/useDynamicStyles';
import type { WithResponsive } from '../utils/responsivity';
import { TextReg } from './StyledText';

type Props = {
  fieldError: { message?: string } | undefined;
  size?: 'small' | 'medium';
};

export function InputError({ fieldError, size = 'medium' }: Props) {
  const styles = useDynamicStyles(createStyles, { size });

  if (!fieldError?.message) {
    return null;
  }

  return <TextReg style={styles.errorText}>{fieldError.message}</TextReg>;
}

const createStyles = ({ size }: WithResponsive<Pick<Props, 'size'>>) =>
  StyleSheet.create({
    errorText: {
      fontSize: 10,
      paddingTop: 4,
      paddingLeft: 16,
      paddingBottom: size === 'small' ? 4 : 8,
      color: Colors.orange0,
    },
  });
